import React, { useState, useContext } from "react";
import './nav.css';
import PasswordResetPopUp from "../login/passwordReset";

import logo from '../media/Picture1.png';
import Button from 'react-bootstrap/Button';
import { Navbar, Nav, NavDropdown, OverlayTrigger, Tooltip, Container, Modal } from "react-bootstrap";
import { Link, Redirect, useHistory } from "react-router-dom";
import app from "../login/firebase";
import { AuthContext } from "../login/Auth";

function UserComponent(props) {
    var user = app.auth().currentUser;
    var email;
    if (user != null) {
        email = user.email;
    }

    const [reset, setReset] = useState(false);

    const showPopUp = () => {
        setReset(true);
    }

    const onHide = () => {
        setReset(false);
    }

    return (
        <>
            <NavDropdown
                title={email}
                alignRight
                className="user-dropdown ms-auto"
            >
                <NavDropdown.Item onClick={() => showPopUp()}>
                    <Nav.Link className="dropdown-link">Request password reset</Nav.Link>
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => {app.auth().signOut()}}>
                    <Nav.Link className="dropdown-link">Sign out</Nav.Link>
                </NavDropdown.Item>
            </NavDropdown>
            <PasswordResetPopUp show={reset} onHide={onHide} email={email} />
        </>
    );
}

class NavigationBar extends React.Component {
    static contextType = AuthContext;

    constructor(props) {
        super(props);
        this.state = { showDeathModal: false };
    }

    componentDidMount() {

    }

    render() {
        var user = app.auth().currentUser;
        var email;
        let { allowEdit } = this.context;

        if (user != null) {
            email = user.email;
        }

        // New patient screen
        if (this.props.newPatient) {
            return (
                <Navbar bg="light" variant="light" expand="lg" className="navbar shadow-sm py-2" sticky="top">
                    <Container fluid>
                        <Navbar.Brand>
                            <Link to={'/'}>
                                <img
                                    src={logo}
                                    className="logo"
                                    alt="Logo"
                                />
                            </Link>
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse className="navbarcol justify-content-end">
                            <Link to={'/'}>
                                <Button variant="outline-danger" className="newButton me-2">
                                    Cancel
                                </Button>
                            </Link>

                            {this.props.disableSubmit ?
                                <OverlayTrigger placement="bottom" overlay={
                                    <Tooltip>
                                        Please select <strong>Gender</strong> and <strong>Patient ID</strong> in <strong>Personal History Tab</strong>
                                    </Tooltip>
                                }>
                                    <span>
                                        <Button
                                            variant="primary"
                                            className="newButton"
                                            style={{ pointerEvents: 'none' }}
                                            disabled={this.props.disableSubmit}
                                            onClick={this.props.submit}
                                        >
                                            Next
                                        </Button>
                                    </span>
                                </OverlayTrigger>
                                :
                                <Button
                                    variant="primary"
                                    className="newButton"
                                    disabled={this.props.disableSubmit}
                                    onClick={(e) => this.props.submit("show")}
                                >
                                    Next
                                </Button>
                            }
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            );
        }
        // Edit mode in edit patient screen
        else if (this.props.editMode) {
            return (
                <Navbar bg="light" variant="light" expand="lg" className="navbar shadow-sm py-2" sticky="top">
                    <Container fluid>
                        <Navbar.Brand>
                            <Link to={'/'}>
                                <img
                                    src={logo}
                                    className="logo"
                                    alt="Logo"
                                />
                            </Link>
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse className="navbarcol justify-content-end">
                            <Button
                                variant="outline-primary"
                                className="newButton me-2"
                                disabled={this.props.disableSubmit}
                                onClick={(e) => this.props.showDateDialog("show")}
                            >
                                Edit date of visit
                            </Button>

                            <Button
                                variant="outline-danger"
                                className="newButton me-2"
                                onClick={() => window.location.reload(false)}
                            >
                                Cancel
                            </Button>

                            <Button
                                variant="success"
                                className="newButton"
                                disabled={this.props.disableSubmit}
                                onClick={this.props.submit}
                            >
                                Submit
                            </Button>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            );
        }
        // Edit demographics screen
        else if (this.props.editDemographics) {
            return (
                <Navbar bg="light" variant="light" expand="lg" className="navbar shadow-sm py-2" sticky="top">
                    <Container fluid>
                        <Navbar.Brand>
                            <Link to={'/'}>
                                <img
                                    src={logo}
                                    className="logo"
                                    alt="Logo"
                                />
                            </Link>
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse className="navbarcol justify-content-end">
                            <Button
                                variant="outline-danger"
                                className="newButton me-2"
                                onClick={() => {this.props.history.goBack()}}
                            >
                                Back
                            </Button>

                            {allowEdit &&
                                <Button
                                    variant="success"
                                    className="newButton"
                                    onClick={this.props.submit}
                                >
                                    Submit
                                </Button>
                            }
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            );
        }
        // Edit patient screen. No edit mode
        else if (this.props.editPatient) {
            return (
                <Navbar bg="light" variant="light" expand="lg" className="navbar shadow-sm py-2" sticky="top">
                    <Container fluid>
                        <Navbar.Brand>
                            <Link to={'/'}>
                                <img
                                    src={logo}
                                    className="logo"
                                    alt="Logo"
                                />
                            </Link>
                        </Navbar.Brand>

                        <div className="patient-info-card bg-white border rounded-3 px-3 py-2 me-auto ms-3 d-flex align-items-center">
                            <div className="me-4">
                                <div className="text-secondary small text-uppercase fw-bold">Patient ID</div>
                                <div className="fw-bold fs-5">{this.props.patient_id}</div>
                            </div>
                            <div className="border-start ps-8">
                                <div className="text-secondary small text-uppercase fw-bold">  Gender</div>
                                <div className="fw-bold fs-5">  {this.props.gender}</div>
                            </div>
                        </div>

                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse className="navbarcol">
                            <Nav className="ms-auto">
                                <Nav.Link><Link to={'/'} className="nav-link-styled">Home</Link></Nav.Link>
                                {allowEdit && <Nav.Link><Link to={'/newPatient'} className="nav-link-styled">New Patient</Link></Nav.Link>}

                                

                                <NavDropdown title="Options" alignRight className="mx-2">
                                    {allowEdit &&
                                        <NavDropdown.Item onClick={this.props.editPopUp}>
                                            <Nav.Link className="dropdown-link">Enable Edit Mode</Nav.Link>
                                        </NavDropdown.Item>
                                    }

                                    {allowEdit &&
                                        <NavDropdown.Item onClick={this.props.renameVisit}>
                                            <Nav.Link className="dropdown-link">Rename Visit</Nav.Link>
                                        </NavDropdown.Item>
                                    }

                                    {allowEdit &&
                                        <NavDropdown.Item onClick={this.props.reorderVisits}>
                                            <Nav.Link className="dropdown-link">Reorder All Visits</Nav.Link>
                                        </NavDropdown.Item>
                                    }

                                    {allowEdit &&
                                        <NavDropdown.Item onClick={this.props.deletePatient}>
                                            <Nav.Link style={{color:'red'}} className="dropdown-link">Delete Patient</Nav.Link>
                                        </NavDropdown.Item>
                                    }
                                </NavDropdown>
                                <Link to={`/editPatient/${this.props.patient_id}/demographics`} className="d-flex align-items-center me-2">
                                    <Button variant="outline-secondary" className="newButton">
                                        Demographics
                                    </Button>
                                </Link>
                                {allowEdit && !this.props.dateOfDeath &&
                                    <Link
                                        to={{
                                            pathname:`/editPatient/${this.props.patient_id}/new/${this.props.newVisit}`,
                                            state:{gender:this.props.gender, "data":this.props.latestVisit, "allVisits":this.props.allVisits}
                                        }}
                                        className="d-flex align-items-center"
                                    >
                                        <Button className="newButton btn-primary">
                                            <span className="me-1">+</span> Insert new Visit
                                        </Button>
                                    </Link>
                                }
                                {allowEdit && this.props.dateOfDeath &&
                                    <Button className="newButton btn-primary" onClick={() => this.setState({showDeathModal: true})}>
                                        <span className="me-1">+</span> Insert new Visit
                                    </Button>
                                }
                                <Modal show={this.state.showDeathModal} onHide={() => this.setState({showDeathModal: false})} centered>
                                    <Modal.Header closeButton>
                                        <Modal.Title className="text-danger">New Visit Not Available</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        A new visit cannot be added because a date of death has been recorded for this patient.
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={() => this.setState({showDeathModal: false})}>Close</Button>
                                    </Modal.Footer>
                                </Modal>
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            );
        }
        // Main nav bar - Home screen
        else {
            return (
                <Navbar bg="light" variant="light" expand="lg" className="navbar shadow-sm py-2">
                    <Container fluid>
                        <Navbar.Brand>
                            <Link to={'/'}>
                                <img
                                    src={logo}
                                    className="logo"
                                    alt="Logo"
                                />
                            </Link>
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse className="navbarcol">
                            <Nav className="me-auto">
                                <Nav.Link><Link to={'/'} className="nav-link-styled">Home</Link></Nav.Link>
                                {allowEdit && <Nav.Link><Link to={'/newPatient'} className="nav-link-styled">New Patient</Link></Nav.Link>}
                            </Nav>
                            <Nav>
                                <Nav.Link>
                                    <Link to={'/auditTrail'} className="nav-link-styled">Audit Trail</Link>
                                </Nav.Link>
                            </Nav>

                            {this.props.addvisit === true &&
                                <Button
                                    onClick={this.props.handleNewVisit}
                                    variant="success"
                                    className="newButton me-3"
                                >
                                    New Visit
                                </Button>
                            }

                            <UserComponent />
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            );
        }
    }
}

Nav.defaultProps = {
    addvisit: false,
    newPatient: false,
    disableSubmit: false
};

export default NavigationBar;